export default __webpack_public_path__ + "static/media/background_d_edit.6acbea90.jpg";